import { createFileRoute } from '@tanstack/react-router'

import { ProductPropertyView } from '@/components/Internal/ProductProperty/ProductPropertyView'
import { SettingsPage } from '@/components/Internal/SettingsPage'

/** The same scrolling ground the lists beside it sit on. */
export const Route = createFileRoute(
  '/internal/system/administration/product-properties',
)({
  component: () => (
    <SettingsPage>
      <ProductPropertyView />
    </SettingsPage>
  ),
})
